export default "__VITE_ASSET__Caj5cN5V__"